// extracted by mini-css-extract-plugin
module.exports = {"other_calc_container":"e2QJg","other_calc_wrap":"Sm0E6","card_container":"kvjpV","calculator_card":"WWQzg"};